export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/qdsbbqZJ3r1i8ghs5agscn/Foto_de_Perfil_de_Facebook_Dia_de_la_Mujer_Vibrante_Rosado_(1).png'

export const PRODUCT_VIDEO_URL = encodeURI(
  'https://cdn.magicpatterns.com/uploads/nxUp1RwKz9QS1TBwz3jMhh/Grabación de pantalla 2026-09-24 a la(s) 01.06.12.mov',
)

export const WHATSAPP_URL = 'https://wa.me/message/QBLVAHVTJJWDF1'

export const INSTAGRAM_URL = 'https://www.instagram.com/profumind.latam/'

export const TEAM_IMAGE_WIDE =
  'https://cdn.magicpatterns.com/patterns/generated-images/91c44564-3312-42f9-a2b2-ccb1b258d16c.jpg'

export const TEAM_IMAGE_PORTRAIT =
  'https://cdn.magicpatterns.com/patterns/generated-images/6088b6b6-366b-49c2-888a-1d4c85184996.jpg'
